import styled from 'styled-components'

import { color } from '../../themes'

export const UnderlineBase = styled.span`
  position: relative;
  display: inline-block;

  &::after {
    content: '';
    position: absolute;
    display: block;
    bottom: 0;
    height: 1px;
    width: 100%;
    background: ${color('gradient.primary')};
  }
`
